import { render, staticRenderFns } from "./VDateFilterPublic.vue?vue&type=template&id=22b7ead6"
import script from "./VDateFilterPublic.vue?vue&type=script&lang=js"
export * from "./VDateFilterPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports